<script setup lang="ts">

import GoalDone from "@/components/Goal/GoalDone.vue";
import {onMounted, ref} from "vue";
import CongratulationPopup from "@/ts/Popup/CongratulationPopup";

const isShowed = ref(false);
const popup = ref<HTMLDivElement>();
onMounted(() => {
  CongratulationPopup.getInstance().init(isShowed, popup.value!);
})
</script>

<template>
  <div class="popup-wrapper"   ref="popup" :class="{show: isShowed}">
    <div class="popup" v-if="isShowed">
      <GoalDone/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.popup {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  &-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 300;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    &.show {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.3s;
    }
  }
}
</style>
